import React from 'react';

import { PushToPreScreeningModal as PushToPreScreeningModalContent } from './PushToPreScreeningModal/PushToPreScreeningModal';

export const PushToPreScreeningDialog = ({
  modalBox,
  selectedPatientIds,
  onPush,
  cachedStudySites,
  onStudySitesLoaded
}) => {
  return (
    <PushToPreScreeningModalContent
      modalBox={modalBox}
      selectedPatientIds={selectedPatientIds}
      onPush={onPush}
      cachedStudySites={cachedStudySites}
      onStudySitesLoaded={onStudySitesLoaded}
    />
  );
};
